import { render, staticRenderFns } from "./business-details.vue?vue&type=template&id=477f9711&scoped=true&"
import script from "./business-details.vue?vue&type=script&lang=js&"
export * from "./business-details.vue?vue&type=script&lang=js&"
import style0 from "./business-details.vue?vue&type=style&index=0&id=477f9711&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f9711",
  null
  
)

export default component.exports